import { create } from "zustand/react";

type StepperState = {
  steps: number;
  currentStep: number;
  setSteps: (n: number) => void;
  next: () => void;
  prev: () => void;
  goTo: (index: number) => void;
  makeSteps: (n?: number) => Step[];
  reset: () => void;
};

type Step = { key: string; isActive: boolean; isDone: boolean };

const makeSteps = (n = 3): Step[] =>
  Array.from({ length: n }, (_, i) => ({
    key: `step${i + 1}`,
    isActive: i === 0,
    isDone: false,
  }));

export const useStepperStore = create<StepperState>((set, _) => ({
  steps: 6,
  currentStep: 0,
  setSteps: (n) => set({ steps: n, currentStep: 0 }),
  makeSteps,
  next: () => set((s) => ({ currentStep: Math.min(s.currentStep + 1, s.steps - 1) })),
  prev: () => set((s) => ({ currentStep: Math.max(s.currentStep - 1, 0) })),
  goTo: (index) => set((s) => ({ currentStep: Math.max(0, Math.min(index, s.steps - 1)) })),
  reset: () => set({ currentStep: 0 }),
}));
